module.exports = __webpack_public_path__ + "static/media/7.b6eedbd7.jpg";